import { ref } from 'vue'

const keyword = ref('')

export const useKeywordSearch = () => {
  const isFocus = ref(false)

  const clearInput = () => {
    keyword.value = ''
  }

  return { keyword, clearInput, isFocus }
}
